const session = window.sessionStorage

export function errorjsonres(message) {
  return {
    'message': message
  }
}

export function setSession(k, v){
  session.setItem(k, v)
}

export function getSession(k){
  return session.getItem(k)
}

export function removeSession(k){
  session.removeItem(k)
}

export function clearSession(){
  session.clear()
}


export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

